// API Configuration
export const API_CONFIG = {
  // Primary API URL
  PRIMARY_URL: 'https://centdos-backend-production.up.railway.app',
  
  // Alternative URLs to try if primary fails
  FALLBACK_URLS: [
    'https://centdos-backend-production.up.railway.app',
    'https://cent2025-production.up.railway.app',
  ],
  
  // Development proxy URL (when using proxy)
  PROXY_URL: '',
  
  // Timeout settings
  TIMEOUT: 10000, // 10 seconds
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Get the current API base URL
export const getApiBaseUrl = (): string => {
  // Always use direct URL since we have the correct endpoint
  return API_CONFIG.PRIMARY_URL;
};

// Check if we're using proxy
export const isUsingProxy = (): boolean => {
  return false; // Always using direct URL now
};
